import { render } from "./ExpenseFeeModalSectionDetails.vue?vue&type=template&id=5aace7cf&scoped=true"
import script from "./ExpenseFeeModalSectionDetails.vue?vue&type=script&lang=js"
export * from "./ExpenseFeeModalSectionDetails.vue?vue&type=script&lang=js"

import "./ExpenseFeeModalSectionDetails.vue?vue&type=style&index=0&id=5aace7cf&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aace7cf"]])

export default __exports__